<template>
    <div
        ref="container"
        class="svg-container"
        :class="{
            [`size-${size}`]: true,
        }"
        :style="computedStyle"
        v-html="svg"
    />
</template>
<script>
export default {
    name: 'FrontifyVector',
    props: {
        // frontify data
        id: {
            type: Number,
            required: false,
            default: 0,
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        name: {
            type: String,
            required: false,
            default: '',
        },
        ext: {
            type: String,
            required: false,
            default: '',
        },
        width: {
            type: Number,
            required: false,
            default: 0,
        },
        height: {
            type: Number,
            required: false,
            default: 0,
        },
        created: {
            type: String,
            required: false,
            default: '',
        },
        generic_url: { // eslint-disable-line vue/prop-name-casing
            type: String,
            required: false,
            default: '',
        },
        preview_url: { // eslint-disable-line vue/prop-name-casing
            type: String,
            required: false,
            default: '',
        },
        src: {
            type: String,
            required: false,
            default: '',
        },
        // actual props
        size: {
            type: String,
            required: false,
            default: 'm',
        },
        maxWidth: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    data() {
        return {
            svg: '',
        };
    },
    computed: {
        computedStyle() {
            if (this.maxWidth > 0) return `max-width: ${this.maxWidth}px`;

            return '';
        },
    },
    async mounted() {
        const resource = await $fetch(this.generic_url);
        this.svg = await resource.text();
    },
};
</script>

<style scoped>
.svg-container {
  display: inline-block;
}
.svg-container.size-xl {
  max-width: 7rem;
}
.svg-container.size-l {
  max-width: 5rem;
}
.svg-container.size-m {
  max-width: 3.5rem;
}
.svg-container.size-s {
  max-width: 2rem;
}
</style>
